//#region Expander

var expander = {
    events: {
        EXPANDED: "expander_expanded",
        BEFORE_EXPANDING: "expander_before_expanding",
    },
    perform($target, $source) {
        if ($target.data('expandedMinimumHeight') == undefined) {
            $target.data('expandedMinimumHeight', $target.height())
        }

        let expandedP = $target.hasClass('expanded')
        expander.onBeforeExpanded($source, $target, !expandedP)

        if (expandedP !== true) {
            let scrollHeight = $target.prop('scrollHeight')

            $target.css('max-height', scrollHeight)
                .addClass('expanded')
            expandedP = true;

            expander.onExpanded($source, expandedP)
        }
        else {
            $target.css('max-height', $target.data('expandedMinimumHeight') + 'px')
            expandedP = false;

            setTimeout(() => {
                $target.removeClass('expanded')
                expander.onExpanded($source, expandedP)
            }, 250)
        }

        if (expandedP) {
            $source.addClass('expanded')
        }
        else {
            $source.removeClass('expanded')
        }
        

    },
    onExpanded($hook, isExpanded) {
        $hook.trigger({
            type: expander.events.EXPANDED,
            isExpanded: isExpanded
        })
    },
    onBeforeExpanded($hook, $target, willExpandP) {
        $hook.trigger({
            type: expander.events.BEFORE_EXPANDING,
            $target: $target,
            willExpandP: willExpandP
        })
    },
}

$(document).on('click', '.toggle-expanded', function () {
    $($(this).data('target')).toggleClass('expanded')
})
$(document).on('click', '.toggle-expanded-by-inner', function () {
    let $target = $($(this).data('target'))
    expander.perform($target, $(this))
})
//#endregion Expander